import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

const ExternalAmountStep = ({
  formData,
  handleInputChange,
  monitoringCenterOptions,
  setFormData,
}) => {
  return (
    <Card className="mb-4">
      <CardHeader>
        <h5 className="mb-0">
          <i className="ni ni-money-coins mr-2" />
          Business Metrics & Monitoring Center
        </h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col md="6">
            <FormGroup className="mb-3">
              <Label htmlFor="requestedAmount">Requested Amount *</Label>
              <Input
                id="requestedAmount"
                type="text"
                inputMode="numeric"
                placeholder="0"
                value={formData.requestedAmount}
                onChange={(e) =>
                  handleInputChange("requestedAmount", e.target.value)
                }
                maxLength={10}
                invalid={
                  formData.requestedAmount &&
                  parseFloat(formData.requestedAmount) <= 0
                }
                bsSize="sm"
              />
              {formData.requestedAmount &&
                parseFloat(formData.requestedAmount) <= 0 && (
                  <div className="invalid-feedback d-block">
                    Requested amount must be greater than 0
                  </div>
                )}
            </FormGroup>
          </Col>
          <Col md="6">
            <FormGroup className="mb-3">
              <Label htmlFor="monitoringCenter">Monitoring Center *</Label>
              <Input
                id="monitoringCenter"
                type="select"
                value={formData.monitoringCenter}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  const selectedOption = monitoringCenterOptions.find(
                    (option) => option.value === selectedValue
                  );
                  setFormData((prev) => ({
                    ...prev,
                    monitoringCenter: selectedValue,
                    monitoringCenterId: selectedOption
                      ? selectedOption.id
                      : null,
                  }));
                }}
                bsSize="sm"
              >
                <option value="">Select Monitoring Center</option>
                {monitoringCenterOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default ExternalAmountStep;

